// Mirror of `config/disposable_email_domains.txt`. Keep in sync by hand:
// any add/remove on the backend list must be reflected here. Lowercase only.
export const DISPOSABLE_EMAIL_DOMAINS: ReadonlySet<string> = new Set([
  '0-mail.com',
  '10minutemail.com',
  '10minutemail.net',
  '20minutemail.com',
  '33mail.com',
  'anonbox.net',
  'anonymbox.com',
  'boun.cr',
  'burnermail.io',
  'byom.de',
  'deadaddress.com',
  'discard.email',
  'discardmail.com',
  'disposablemail.com',
  'dispostable.com',
  'dropmail.me',
  'e4ward.com',
  'emailondeck.com',
  'emailsensei.com',
  'emailtemporanea.net',
  'emltmp.com',
  'fakeinbox.com',
  'fakemail.net',
  'fakemailgenerator.com',
  'get2mail.fr',
  'getairmail.com',
  'getnada.com',
  'gmial.com',
  'grr.la',
  'guerrillamail.biz',
  'guerrillamail.com',
  'guerrillamail.de',
  'guerrillamail.info',
  'guerrillamail.net',
  'guerrillamail.org',
  'guerrillamailblock.com',
  'harakirimail.com',
  'hidemyass.com',
  'hotmail.con',
  'hotnail.com',
  'inboxalias.com',
  'inboxbear.com',
  'incognitomail.com',
  'jetable.org',
  'junkmail.com',
  'kasmail.com',
  'mailcatch.com',
  'maildrop.cc',
  'maildrop.email',
  'mailexpire.com',
  'mailforspam.com',
  'mailimate.com',
  'mailinator.com',
  'mailinator.net',
  'mailinator.org',
  'mailnesia.com',
  'mailnull.com',
  'mailtemp.info',
  'mintemail.com',
  'mohmal.com',
  'mt2015.com',
  'mt2016.com',
  'mvrht.com',
  'mytemp.email',
  'nada.email',
  'no-spam.ws',
  'notmailinator.com',
  'nowmymail.com',
  'proxymail.eu',
  'rcpt.at',
  'sharklasers.com',
  'sneakmail.com',
  'sogetthis.com',
  'spam4.me',
  'spamavert.com',
  'spamex.com',
  'spamgourmet.com',
  'spamspot.com',
  'suremail.info',
  'tempail.com',
  'temp-mail.io',
  'temp-mail.org',
  'tempemail.net',
  'tempinbox.com',
  'tempmail.de',
  'tempmail.us',
  'tempmailaddress.com',
  'tempmailo.com',
  'temporarymail.com',
  'tmpmail.net',
  'trash-mail.com',
  'trashmail.com',
  'trashmail.de',
  'trashmail.net',
  'trbvm.com',
  'tuvm.cf',
  'yopmail.com',
  'yopmail.fr',
  'yopmail.net',
  'zetmail.com',
]);

export function isDisposableEmail(email: string): boolean {
  const domain = email.split('@')[1]?.toLowerCase();
  if (!domain) return false;
  return DISPOSABLE_EMAIL_DOMAINS.has(domain);
}
